<template>
    <div>      
        <card :title="cart_title">
            <table class="table" v-if="numInCart > 0">                
                <tbody>                  
                    <tr v-for="(item, index) in inCart">
                        <td>                                                  
                            <strong>{{ item.sku }}</strong><br/>
                            <small>{{ item.name }}</small>
                            <slot v-if="item.in_warranty">
                                <i class="fas fa-certificate text-warning" :title="$t('part.inwarranty')"></i>
                            </slot>
                            <slot v-if="item.inventory_type_id == 1">
                                <i class="fas fa-certificate text-primary" :title="$t('part.fromstock')"></i>
                            </slot>
                            <slot v-if="item.inventory_type_id == 2">
                                <i class="fas fa-certificate text-success" :title="$t('part.earlykit')"></i>
                            </slot>
                            <slot v-if="item.inventory_type_id == 3">
                                <i class="fas fa-certificate text-dark" :title="$t('part.cannibalization')"></i>
                            </slot>
                        </td>
                        <td class="text-right text-nowrap">                          
                            <a
                                href
                                class="badge badge-danger"
                                @click.prevent="increase(index)"
                                v-if="showButtons"
                            >
                                <i class="fas fa-plus"></i>
                            </a>
                            <span
                                class="d-inline-block text-center"
                                style="width:20px"
                            >{{ item.quantity }}</span>
                            <a
                                href
                                class="badge badge-danger"
                                @click.prevent="decrease(index)"
                                v-if="showButtons"
                            >
                                <i class="fas fa-minus"></i>
                            </a>
                            &nbsp;&nbsp;
                            <slot v-if="item.inventory_type_id == 3 && showButtons">
                                <a
                                    href
                                    @click.prevent="toggleRemove(index)"
                                    class="text-danger"
                                    style="font-size: 10px;"
                                >
                                    <span
                                        class="fa-stack fa-xs"
                                        v-if="item.remove_from_stock == true"
                                        :title="$t('part.button.removefromstock')"
                                    >
                                        <i class="fas fa-trash text-primary fa-stack-2x"></i>
                                        <i
                                            class="fas fa-arrow-down text-primary fa-stack-1x"
                                            style="margin-top:-12px;"
                                        ></i>
                                    </span>
                                    <span
                                        class="fa-stack fa-xs"
                                        v-if="item.remove_from_stock == false"
                                        title="Keep in Stock"
                                    >
                                        <i
                                            class="fas fa-trash text-muted fa-stack-2x"
                                            style="vertical-align:bottom"
                                        ></i>
                                    </span>
                                </a>
                            </slot>
                            <slot v-if="item.inventory_type_id == 3 && !showButtons">
                                <span
                                    class="fa-stack fa-xs"
                                    v-if="item.remove_from_stock == true"
                                    title="Remove from Stock"
                                >
                                    <i class="fas fa-trash text-primary fa-stack-2x"></i>
                                    <i
                                        class="fas fa-arrow-down text-primary fa-stack-1x"
                                        style="margin-top:-12px;"
                                    ></i>
                                </span>
                                <span
                                    class="fa-stack fa-xs"
                                    v-if="item.remove_from_stock == false"
                                    title="Keep in Stock"
                                >
                                    <i
                                        class="fas fa-trash text-muted fa-stack-2x"
                                        style="vertical-align:bottom"
                                    ></i>
                                </span>
                            </slot>
                        </td>
                        <td class="text-right">{{ item.price | dollars }}</td>
                        <td class="text-right" v-if="showButtons">
                            <a
                                href
                                class="badge badge-danger"
                                @click.prevent="removeFromCart(index)"
                            >
                                <i class="fas fa-times"></i>
                            </a>
                        </td>
                    </tr>
                    <tr class="bg-light" v-if="numInCart > 0">
                        <th>
                            <b>{{$t('text.total')}}</b>
                        </th>
                        <th></th>
                        <th width="1%" v-if="showOptions"></th>
                        <th class="text-right">{{ total | dollars }}</th>
                        <th width="1%" v-if="showButtons"></th>
                    </tr>
                </tbody>
            </table>
            <div class="text-center" v-if="numInCart == 0">
                <b>{{$t('text.empty')}}</b>
            </div>
            <div class="text-right" v-if="numInCart > 0 && showButtons && showRequestButton">
                <button class="btn btn-primary btn-block" @click="submitAndClose">{{$t('part.button.requestparts')}}</button>
            </div>
        </card>
    </div>
</template>

<script>
import { dollars } from "@/helpers/filters";

export default {
  name: "shoppingCart",
  props: {
    showButtons: true,
    showRequestButton: true,
    showOptions: true,
    showUsedParts: false, //marcel 2020-03-22
    default_asf: null,
    cart_title: {
      default: "Parts Request",
      type: String
    }
  },
  data() {
    return {
      showModal: false,
      form: {
        cart: {},
        asf_id: "",
        asfs: []
      },
      check_remove: false
    };
  },
  computed: {
    isCanon() {
      if (!this.default_asf) {
        return this.$store.getters["auth/getIsCanon"];
      } else {
        return this.default_asf == 14;
      }
    },
    all() {      
      return this.$store.getters["cart/all"] || {};
    },
    inCart() {
      if(this.showUsedParts){ //marcel 2020-03-22                
        return this.$store.getters["cart/inCartUsedParts"] || {};
      } else {         
        return this.$store.getters["cart/inCart"] || {};
      }
    },
    numInCart() {
      return this.inCart.length || 0;
    },
    total() {
      return this.inCart.reduce(
        (acc, cur) => parseFloat(acc) + parseFloat(cur.price),
        0
      );
    }
  },
  console: () => console,
  filters: {
    dollars
  },
  methods: {
    asfLabel({ name, vat }) {
      return `${name} — ${vat}`;
    },
    selectAsfs(option) {
      this.$store.commit("auth/setCurrentAsf", option.id);
    },
    setValue(item, type) {            
      if (type == "w") this.$store.commit("cart/setCartInWarranty", item);
      if (type == "s") this.$store.commit("cart/setCartFromStock", item);
    },
    toggleRemove(index) {
      this.check_remove = !this.check_remove;
      this.$store.dispatch("cart/toggleRemove", index);
    },
    removeFromCart(index) {
      this.$store.dispatch("cart/removeFromCart", index);
    },
    decrease(part) {
      this.$store.dispatch("cart/decreaseQuantity", part);
    },
    increase(part) {
      this.$store.dispatch("cart/increaseQuantity", part);
    },
    submitAndClose() {
      this.form.cart = this.$store.getters["cart/inCart"];
      this.form.asf_id = !this.default_asf
        ? this.$store.getters["auth/getCurrentAsf"]
        : this.default_asf;
      this.$store
        .dispatch("requests/create", this.form)
        .then(result => {
          if (this.$store.getters["auth/getSessionRoles"].includes("admin")) {
            this.$store.commit("auth/setCurrentAsf", null);
          }
          this.$router.push({ name: "requests" });
          this.$notify({
            type: "success",
            message: "Request created with success!"
          });
        })
        .catch(error => {
          let msg = "";
          if (error.response.data) {
            msg = error.response.data.errors[0].detail;
          } else {
            msg = error.response.message;
          }
          this.$notify({
            type: "danger",
            horizontalAlign: "center",
            message: msg
          });
        });
    }
  }
};
</script>

<style>
.modal {
  background: rgba(0, 0, 0, 0.5);
}
</style>
